import * as React from 'react'
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    qrodeImg: string,
    qrcodeAlipayImg: string,
    qrcodeWechatImg?: string,
    intl: IntlShape
}

interface IState {
}

class Qrcodes extends React.Component<IProps, IState> {
    public render() {
        let {qrodeImg, qrcodeAlipayImg, qrcodeWechatImg, intl} = this.props
        return (
            <div className="section-settings">
                <h3>{intl.formatMessage({id: 'merchantQr'})}</h3>
                <div className="content clear">
                    <div className="qrcode">
                        <img src={qrodeImg} alt="qrocde"/>
                        <a className="button" href={qrodeImg} download={true}>{intl.formatMessage({id: 'download'})}</a>
                    </div>
                    <div className="qrcode">
                        <img src={qrcodeAlipayImg} alt="Alipay qrcode"/>
                        <a className="button" href={qrcodeAlipayImg} download={true}>{intl.formatMessage({id: 'download'})}</a>
                    </div>
                    {
                        qrcodeWechatImg ? (<div className="qrcode">
                            <img src={qrcodeWechatImg} alt="Wechat qrcode"/>
                            <a className="button" href={qrcodeWechatImg} download={true}>{intl.formatMessage({id: 'download'})}</a>
                        </div>) : null
                    }
                </div>
            </div>
        );
    }
}

export default injectIntl(Qrcodes)
